import React, { PropsWithChildren, JSX } from 'react'
import { StyleProps } from 'common-types'

type DivProps = JSX.IntrinsicElements['div']

export interface FormGroupProps extends DivProps {
    column?: true | boolean
    wrap?: true
    style?: StyleProps
    flexibleSize?: true
    flexGrowItems?: number[]
    alignItems?: string
    fragmentItemContainer?: true
}

export const FormGroup = (props: PropsWithChildren<FormGroupProps>) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: props.column ? 'column' : 'row',
                alignItems: !props.alignItems
                    ? props.column
                        ? 'stretch'
                        : 'center'
                    : props.alignItems,
                gap: 10,
                ...props.style,
                flexWrap: props.wrap ? 'wrap' : undefined,
            }}
            className={props.className}
        >
            {React.Children.map(props.children, (child, i) => {
                if (child == null) {
                    return
                }

                if (props.fragmentItemContainer) {
                    return <React.Fragment>{child}</React.Fragment>
                }

                const flexGrowItem =
                    props.flexGrowItems && props.flexGrowItems[i] !== undefined
                        ? props.flexGrowItems[i]
                        : 1

                return (
                    <div
                        key={i}
                        style={{
                            display: 'flex',
                            width: props.column
                                ? undefined
                                : props.flexibleSize
                                ? undefined
                                : '30%',
                            flexGrow: flexGrowItem,
                        }}
                    >
                        {child}
                    </div>
                )
            })}
        </div>
    )
}
